/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { NotificationUnreadCountResponse } from '../types/NotificationUnreadCount'

/**
 * GET /notifications/unread-count
 * @see backend/nexus/modules/Campaign/Http/Controllers/NotificationController.php NotificationController::unreadCount
 */
export async function notificationUnreadCount(
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<NotificationUnreadCountResponse>> {
	return axiosInstance.get('/notifications/unread-count', config)
}
